import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=0df52644&scoped=true"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"
import style0 from "./FormInput.vue?vue&type=style&index=0&id=0df52644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df52644",
  null
  
)

export default component.exports